export const PractitionerPractice = "^[0-9a-zA-Z \\-'&!+\\/@.,_?]*$"
export const PractitionerAddress = "^[0-9a-zA-Z \\-'&!+\\/@.,_?]*$"